export default "__VITE_ASSET__D0IZ0Xip__"